/* Wuschelherz: aus snippets/wh-bundle-flow.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
  (() => {
    if (window.whBundle) return;
    const KEY = 'wh-bundle', TTL = 2 * 60 * 60 * 1000;
    const store = (() => { try { localStorage.setItem('wh-t', '1'); localStorage.removeItem('wh-t'); return localStorage; } catch (e) { try { return sessionStorage; } catch (e2) { return null; } } })();
    const read = () => {
      if (!store) return null;
      try {
        const s = JSON.parse(store.getItem(KEY) || 'null');
        if (!s || !Array.isArray(s.items) || !s.items.length) return null;
        if (Date.now() - (s.ts || 0) > TTL) { store.removeItem(KEY); return null; }
        return s;
      } catch (e) { return null; }
    };
    const write = (s) => { if (!store) return; try { if (s) { s.ts = Date.now(); store.setItem(KEY, JSON.stringify(s)); } else store.removeItem(KEY); } catch (e) {} };
    const path = (u) => { try { return new URL(u, location.origin).pathname; } catch (e) { return ''; } };
    const nextOpen = (s, from) => { for (let i = from; i < s.items.length; i++) if (!s.items[i].st) return i; for (let i = 0; i < s.items.length; i++) if (!s.items[i].st) return i; return -1; };
    const doneCount = (s) => s.items.filter((i) => i.st === 'done').length;
    const urlFor = (s, i) => { const u = new URL(s.items[i].url, location.origin); if (doneCount(s) > 0) u.searchParams.set('wh_auto', '1'); return u.pathname + u.search; };
    const go = (s, i) => { s.pos = i; write(s); location.href = urlFor(s, i); };
    const handleOf = (u) => (path(u) || '').split('/').filter(Boolean).pop();
    const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    const isCart = /^\/cart\/?$/.test(location.pathname);
    const isProduct = /^\/products\//.test(location.pathname);
    // Sofortkauf (wh-pdp-r3): landet Teeinblue nach „Jetzt kaufen“ auf /cart, geht es sofort weiter zur Kasse
    const NEXT = 'wh-bf-next';
    const pendingNext = () => { try { const n = JSON.parse(sessionStorage.getItem(NEXT) || 'null'); return n && Date.now() - n.ts < 30000 ? n : null; } catch (e) { return null; } };
    if (isCart) {
      const n = pendingNext();
      if (n) { try { sessionStorage.removeItem(NEXT); sessionStorage.removeItem('wh-instant'); } catch (e) {} location.replace(n.url); return; }
      try {
        const t = parseInt(sessionStorage.getItem('wh-instant') || '0', 10);
        if (t && Date.now() - t < 90000) { sessionStorage.removeItem('wh-instant'); location.replace('/checkout'); return; }
      } catch (e) {}
    }

    // ---------- Leiste oben ----------
    const renderBar = () => {
      const s = read();
      document.documentElement.classList.toggle('wh-bf-active', !!s);
      document.documentElement.classList.toggle('wh-bf-open', !!(s && !s.complete));
      let bar = document.getElementById('WhBundleBar');
      if (!s || s.complete || isCart) { if (bar) bar.hidden = true; return; }
      const main = document.getElementById('MainContent'); if (!main) return;
      if (!bar) { bar = document.createElement('div'); bar.id = 'WhBundleBar'; bar.className = 'wh-bf'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Dein Sparpaket'); main.prepend(bar); }
      const n = s.items.length;
      // Steht die Kundin auf einem Bild des Bundles (z. B. nach der Zurück-Taste), zählt diese Seite
      const here = isProduct ? s.items.findIndex((it) => handleOf(it.url) === handleOf(location.pathname)) : -1;
      if (here > -1 && !s.items[here].st && here !== s.pos) { s.pos = here; write(s); }
      const now = s.pos, cur = s.items[now];
      const onDone = here > -1 && s.items[here].st === 'done';
      // 2026-10-27 (Lukas): Bilder in der Leiste antippen führt zurück zum jeweiligen Design mit seiner Auswahl
      const steps = '<ol class="wh-bf__steps">' + s.items.map((it, i) => {
        const img = it.thumb ? '<img src="' + esc(it.thumb) + '" alt="" width="28" height="28">' : '';
        const label = 'Bild ' + (i + 1) + (it.title ? ': ' + it.title : '') + (it.st === 'done' ? ' (im Warenkorb)' : '');
        const href = it.st === 'done' ? it.url : urlFor(s, i);
        return '<li class="' + (it.st === 'done' ? 'is-done' : it.st === 'skip' ? 'is-skip' : i === now ? 'is-now' : '') + '"><a href="' + esc(href) + '"' + (it.st === 'done' ? '' : ' data-wh-bf-go="' + i + '"') + ' aria-label="' + esc(label) + '">' + img + '</a></li>';
      }).join('') + '</ol>';
      const onIt = here > -1 && here === now;
      bar.innerHTML = steps +
        '<p class="wh-bf__text">' + (onIt ? '<strong>Bild ' + (now + 1) + ' von ' + n + '</strong>' + (cur ? ' · ' + esc(cur.title) : '') : onDone ? 'Bild ' + (here + 1) + ' liegt schon im Warenkorb. <strong>Weiter mit Bild ' + (now + 1) + '</strong>' : 'Dein Sparpaket: <strong>Bild ' + (now + 1) + ' von ' + n + '</strong> ist dran') + '</p>' +
        '<div class="wh-bf__actions">' +
          (onIt ? '<button type="button" class="wh-bf__btn" data-wh-bf="skip">Dieses Design überspringen</button>' : '<button type="button" class="wh-bf__btn wh-bf__btn--main" data-wh-bf="resume">Weiter</button>') +
          '<button type="button" class="wh-bf__btn" data-wh-bf="end">Sparpaket verwerfen</button>' +
        '</div>';
      // Bestätigung vom vorigen Bild
      try {
        const msg = sessionStorage.getItem('wh-bf-toast');
        if (msg && isProduct) { sessionStorage.removeItem('wh-bf-toast'); const t = document.createElement('div'); t.className = 'wh-bf-toast'; t.setAttribute('role', 'status'); t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>' + esc(msg); document.body.appendChild(t); setTimeout(() => t.remove(), 3800); }
      } catch (e) {}
      bar.hidden = false;
    };

    // ---------- Warenkorb: Weiter-Knopf über „Zur Kasse“ ----------
    // legal-check Runde 4: Abschlusstext nur nach dem echten Warenkorb (Anzahl Artikel vom Typ Poster aus /cart.js),
    // nicht nach dem Zähler des Ablaufs. Shopify rechnet den Rabatt ab 2 Bildern.
    let cartCount = null, cartAt = 0;
    // Schritt 40 (2026-10-21, Lukas: Warenkorb zeigte „Weiter mit Bild 1“, obwohl das Bild schon drin lag): Warteschlange mit dem
    // echten Warenkorb abgleichen. Liegt ein Bild (Handle) im Warenkorb, gilt der passende offene Eintrag als erledigt. Das fängt
    // auch Wege ab, die /cart/add.js nicht über fetch oder XHR nehmen.
    const reconcile = (s, items) => {
      if (!s || s.complete) return false;
      const pool = items.filter((i) => i.product_type === 'Poster').map((i) => i.handle);
      const take = (it) => { const k = pool.indexOf(handleOf(it.url)); if (k > -1) { pool.splice(k, 1); return true; } return false; };
      s.items.forEach((it) => { if (it.st === 'done') take(it); });
      let changed = false;
      s.items.forEach((it) => { if (!it.st && take(it)) { it.st = 'done'; changed = true; } });
      if (changed) { const i = nextOpen(s, 0); if (i < 0) s.complete = true; else s.pos = i; write(s); }
      return changed;
    };
    const loadCart = () => {
      if (Date.now() - cartAt < 4000) return;
      cartAt = Date.now();
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => {
        const items = c.items || [];
        const n = items.filter((i) => i.product_type === 'Poster').reduce((a, i) => a + i.quantity, 0);
        const changed = reconcile(read(), items);
        if (changed) renderBar();
        if (n !== cartCount || changed) { cartCount = n; renderCart(); }
      }).catch(() => {});
    };
    const renderCart = () => {
      const s = read();
      const targets = Array.from(document.querySelectorAll('cart-drawer [name="checkout"], main [name="checkout"]'));
      if (!s) { document.querySelectorAll('.wh-bfc').forEach((el) => el.remove()); return; }
      loadCart();
      const total = s.items.length, done = doneCount(s);
      let html;
      if (s.complete || nextOpen(s, 0) < 0) {
        // Ein einzelnes Bild ist kein Bundle: Ablauf still beenden, kein Kasten
        if (total < 2) { write(null); document.querySelectorAll('.wh-bfc').forEach((el) => el.remove()); renderBar(); return; }
        const n = cartCount === null ? done : cartCount;
        html = n >= 2
          ? '<p class="wh-bfc__title">Dein Sparpaket ist komplett</p><p>' + n + ' Bilder liegen im Warenkorb. Der Mengenrabatt wird automatisch abgezogen.</p>'
          : '<p class="wh-bfc__title">' + (n === 1 ? 'Dein Bild liegt im Warenkorb' : 'Sparpaket beendet') + '</p>';
      } else {
        const i = nextOpen(s, s.pos);
        html = '<p class="wh-bfc__title">' + (done ? 'Bild ' + done + ' von ' + total + ' liegt im Warenkorb' : 'Dein Sparpaket: ' + total + (total === 1 ? ' Bild' : ' Bilder')) + '</p>' +
          '<a class="wh-bfc__next" href="' + esc(urlFor(s, i)) + '" data-wh-bf-go="' + i + '">Weiter mit Bild ' + (i + 1) + ': ' + esc(s.items[i].title) + ' <span aria-hidden="true">&rarr;</span></a>' +
          '<button type="button" class="wh-bfc__end" data-wh-bf="end">Sparpaket verwerfen</button>';
      }
      targets.forEach((btn) => {
        const host = btn.parentElement;   // Seite: div.grid, Drawer: form.drawer__footer-buttons
        if (!host) return;
        let box = host.previousElementSibling && host.previousElementSibling.classList.contains('wh-bfc') ? host.previousElementSibling : null;
        if (!box) { box = document.createElement('div'); box.className = 'wh-bfc'; box.setAttribute('role', 'status'); host.before(box); }
        // Vergleich über die Quelle, nicht innerHTML (der Browser normalisiert Entities, sonst Endlosschleife mit dem Observer)
        if (box.dataset.html !== html) { box.dataset.html = html; box.innerHTML = html; }
      });
    };

    // ---------- Klicks ----------
    document.addEventListener('click', (event) => {
      const t = event.target.closest('[data-wh-bf], [data-wh-bf-go]');
      if (t) {
        const s = read(); if (!s) return;
        // Der Link trägt schon das Ziel: nur die Position merken und den Browser selbst navigieren lassen (robuster in Safari)
        if (t.hasAttribute('data-wh-bf-go')) { const i = parseInt(t.getAttribute('data-wh-bf-go'), 10); if (s.items[i] && s.items[i].st === 'skip') s.items[i].st = ''; s.pos = i; write(s); return; }
        const a = t.getAttribute('data-wh-bf');
        if (a === 'end') { write(null); renderBar(); renderCart(); return; }
        if (a === 'resume') { go(s, Math.max(0, nextOpen(s, s.pos))); return; }
        if (a === 'skip') {
          s.items[s.pos].st = 'skip';
          const i = nextOpen(s, s.pos + 1);
          if (i < 0) { s.complete = true; write(s); location.href = '/cart'; } else go(s, i);
          return;
        }
      }
      // Zur Kasse mit komplettem Bundle: Ablauf ist fertig
      if (event.target.closest('[name="checkout"]')) { const s = read(); if (s && (s.complete || nextOpen(s, 0) < 0)) write(null); }
    }, true);

    // ---------- In den Warenkorb erkannt (Teeinblue: POST /cart/add.js) ----------
    const chainHere = () => { const s = read(); if (!s || s.complete || !isProduct) return -1; return s.items.findIndex((it) => !it.st && handleOf(it.url) === handleOf(location.pathname)); };
    const markAdded = () => {
      const s = read(); if (!s || s.complete) return 'none';
      const k = chainHere(); if (k < 0) return 'none';   // anderes Produkt: normaler Ablauf
      s.items[k].st = 'done';
      const i = nextOpen(s, k + 1);
      if (i < 0) s.complete = true; else s.pos = i;
      write(s);
      document.dispatchEvent(new CustomEvent('wh:bundle-added', { detail: { state: s } }));
      if (i > -1) {
        // Kette: nicht in den Warenkorb, sondern direkt zum nächsten Design (auch bei „Jetzt kaufen“)
        const url = urlFor(s, i);
        try { sessionStorage.removeItem('wh-instant'); sessionStorage.setItem(NEXT, JSON.stringify({ url, ts: Date.now() })); sessionStorage.setItem('wh-bf-toast', 'Bild ' + (k + 1) + ' ist im Warenkorb'); } catch (e) {}
        document.documentElement.classList.add('wh-bf-going');
        const note = document.createElement('div'); note.className = 'wh-bf-going-note'; note.setAttribute('role', 'status'); note.textContent = 'Weiter mit Bild ' + (i + 1) + ' …'; document.body.appendChild(note);
        setTimeout(() => { location.href = url; }, 400);
        return 'next';
      }
      return 'last';
    };
    // Nach dem Hinzufügen: Zähler und Drawer aktualisieren, dann Bestätigung bzw. Drawer (letztes Bundle-Bild)
    const instantNow = () => { try { const t = parseInt(sessionStorage.getItem('wh-instant') || '0', 10); return t && Date.now() - t < 90000; } catch (e) { return false; } };
    const openDrawer = () => { const cd = document.querySelector('cart-drawer'); document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: !!cd } })); if (!cd) location.href = '/cart'; };
    const toast = () => {
      document.querySelectorAll('.wh-atc-toast').forEach((t) => t.remove());
      const t = document.createElement('div'); t.className = 'wh-atc-toast'; t.setAttribute('role', 'status');
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg><span>Im Warenkorb</span><a href="/cart" data-wh-atc-open>Zum Warenkorb</a>';
      document.body.appendChild(t);
      setTimeout(() => { t.classList.add('is-out'); setTimeout(() => t.remove(), 350); }, 5000);
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('[data-wh-atc-open]');
      if (!a || !document.querySelector('cart-drawer')) return;
      e.preventDefault(); a.closest('.wh-atc-toast').remove(); openDrawer();
    });
    const afterAdd = (result) => {
      if (result === 'next' || instantNow()) return;   // Kette läuft weiter bzw. „Jetzt kaufen“ geht zur Kasse
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => {
        try { if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'wh-atc', cart }); } catch (e) {}
        if (result === 'last') openDrawer();
        else { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })); toast(); }
      }).catch(() => { if (result === 'last') location.href = '/cart'; });
    };
    if (isProduct) {
      const isAdd = (u) => /\/cart\/add(\.js)?(\?|$)/.test(String(u || ''));
      let last = 0;
      // „Zweites Bild gestalten“: nach dem Hinzufügen zum Baukasten statt Bestätigung (Gültigkeit 90 s wie „Jetzt kaufen“, KI-Designs brauchen länger)
      const MORE = 'wh-more';
      const morePending = () => { try { const m = JSON.parse(sessionStorage.getItem(MORE) || 'null'); return m && Date.now() - m.ts < 90000 ? m : null; } catch (e) { return null; } };
      const toBuilder = (m) => {
        try { sessionStorage.removeItem(MORE); } catch (e) {}
        document.documentElement.classList.add('wh-bf-going');
        const note = document.createElement('div'); note.className = 'wh-bf-going-note'; note.setAttribute('role', 'status'); note.textContent = 'Bild 1 ist im Warenkorb. Weiter zum Sparpaket …'; document.body.appendChild(note);
        // eine Digitale Datei legt wh-pdp-r3 direkt danach hinzu (window.whDdWait): erst danach weiter
        setTimeout(() => { const w = window.whDdWait; const go2 = () => { location.href = m.url; }; if (w && w.finally) w.finally(go2); else go2(); }, 400);
      };
      const added = () => {
        if (Date.now() - last < 2000 || Date.now() - (window.whDdAdding || 0) < 5000) return; last = Date.now();
        const m = morePending();
        if (m && chainHere() < 0) return toBuilder(m);
        afterAdd(markAdded());
      };
      document.addEventListener('click', (e) => {
        const a = e.target.closest && e.target.closest('[data-wh-more]');
        if (!a || chainHere() > -1) return;   // im laufenden Sparpaket gilt die Kette
        const atc = document.querySelector('.tee-btn--atc');
        if (!atc) return;   // ohne Gestalter wie bisher direkt zum Baukasten
        e.preventDefault();
        const u = new URL(a.href, location.origin); u.searchParams.set('drin', '1');
        try { sessionStorage.removeItem('wh-instant'); sessionStorage.setItem(MORE, JSON.stringify({ url: u.pathname + u.search, ts: Date.now() })); } catch (err) {}
        const label = a.dataset.label || a.textContent; a.dataset.label = label; a.textContent = 'Bild 1 kommt in den Warenkorb …'; a.setAttribute('aria-busy', 'true');
        setTimeout(() => { a.textContent = label; a.removeAttribute('aria-busy'); }, 6000);
        moreAt = Date.now();
        atc.click();   // fehlt etwas (Foto, Name), zeigt Teeinblue den Hinweis, dann passiert nichts weiter
      }, true);
      // Gestaltet die Kundin nach dem Hinweis weiter, gilt der Klick als abgebrochen (späteres „In den Warenkorb“ läuft normal)
      let moreAt = 0;
      const moreCancel = (e) => {
        if (!e.isTrusted || !moreAt || Date.now() - moreAt < 1500 || !e.target.closest || !e.target.closest('.tee-customization-wrapper')) return;
        moreAt = 0; try { sessionStorage.removeItem(MORE); } catch (err) {}
      };
      document.addEventListener('input', moreCancel, true);
      document.addEventListener('change', moreCancel, true);
      // Teeinblue nicht mehr auf /cart weiterleiten lassen (Optionen liest Teeinblue aus window.teeinblue)
      const noRedirect = () => { try { const o = window.teeinblue || {}; if (o.cartRedirectDelay !== 2147483647) window.teeinblue = Object.assign(o, { cartRedirectDelay: 2147483647, successMessage: 'Dein Unikat liegt im Warenkorb.' }); } catch (e) {} };
      noRedirect(); document.addEventListener('DOMContentLoaded', noRedirect); window.addEventListener('load', noRedirect); setTimeout(noRedirect, 3000);
      const of = window.fetch;
      window.fetch = function (input) { const u = typeof input === 'string' ? input : (input && input.url) || ''; const p = of.apply(this, arguments); if (isAdd(u)) p.then((r) => { if (r && r.ok) added(); }).catch(() => {}); return p; };
      const oo = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) { if (isAdd(u)) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) added(); }); return oo.apply(this, arguments); };
    }

    window.whBundle = {
      start(items) {
        // 2026-10-27: Vorwahl und UTM im Link behalten (nur Seiten dieses Shops)
        const keep = (u) => { try { const x = new URL(u, location.origin); return x.origin === location.origin ? x.pathname + x.search : ''; } catch (e) { return ''; } };
        const list = (items || []).filter((i) => i && i.url).map((i) => ({ url: keep(i.url) || path(i.url) || i.url, title: i.title || '', thumb: i.thumb || '', st: i.st === 'done' ? 'done' : '' }));
        if (!list.length) return;
        const s = { v: 1, items: list, pos: 0 };
        const i = nextOpen(s, 0);
        if (i < 0) { location.href = '/cart'; return; }   // alles liegt schon im Warenkorb
        go(s, i);
      },
      state: read,
      // true, solange auf dieser Seite ein Bundle-Bild offen ist und danach noch weitere kommen
      chainOpen() { const s = read(); if (!s || s.complete) return false; const k = chainHere(); if (k < 0) return false; return s.items.some((it, j) => j !== k && !it.st); },
      end() { write(null); try { sessionStorage.removeItem(NEXT); } catch (e) {} renderBar(); renderCart(); }
    };

    if (isProduct) { try { sessionStorage.removeItem(NEXT); } catch (e) {} }
    const run = () => { document.documentElement.classList.remove('wh-bf-going'); renderBar(); renderCart(); };
    const start = () => {
      run();
      let t; new MutationObserver((list) => {
        if (list.every((m) => m.target.closest && m.target.closest('.wh-bfc, #WhBundleBar'))) return;   // eigene Änderungen ignorieren
        clearTimeout(t); t = setTimeout(renderCart, 120);
      }).observe(document.body, { childList: true, subtree: true });
      window.addEventListener('pageshow', run);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
